import { useEffect } from 'react'

import styles from './course-by-student.module.scss'

import { InstitutionsService } from '@/services/institutions'
import { useValidateSchema } from '@/hooks/useSchemaValidator'
import { useListCourses } from '@/pages/@hooks/use-list-courses'
import { CoursesService } from '@/services/courses/course.service'
import {
  courseAndInstitutionRegisterFormDataSchema,
  CourseAndInstitutionRegisterFormDataSchemaType,
} from '@/utils/schemas/courseAndInstitutionRegisterFormDataSchema'
import { useEditRegisteredCourse } from '@/pages/@hooks/use-edit-registered-course'
import { useListInstitutions } from '@/pages/admin/pages/institutions/@hooks/use-list-institutions'

import { Loader } from '@/components/Loader'
import { Course } from '@/domain/entities/course.entity'
import { FooterButtons } from '@/components/FooterButtons'
import { CustomerSelect } from '@/components/Select/selectCustomized'

const courseService = new CoursesService()
const institutionsService = new InstitutionsService()

export const CoursesByStudent = () => {
  const {
    institution,
    enrolledCourses,
    registrations,
    courseOptions,
    filterCoursesByInstitution,
  } = useListCourses({
    courseService,
  })

  const { institutionOptions } = useListInstitutions({
    institutionsService,
  })

  const { register, handleSubmit, setValue } = useValidateSchema(
    courseAndInstitutionRegisterFormDataSchema as unknown as CourseAndInstitutionRegisterFormDataSchemaType,
    {
      course_id: enrolledCourses?.id?.toString(),
      institution_id: institution?.id?.toString(),
    },
  )

  const { mutation } = useEditRegisteredCourse({
    courseService,
    id: registrations?.length > 0 ? +registrations[0].id : 1,
  })

  const onSubmitForm = (
    data: CourseAndInstitutionRegisterFormDataSchemaType,
  ) => {
    const registration: any = registrations[0]
    mutation.mutate({
      idaluno: registration.idaluno,
      idcurso: +data.course_id,
      idinstituicao: +data.institution_id,
    } as unknown as Course)
  }

  useEffect(() => {
    setValue('course_id', enrolledCourses?.id?.toString())
    setValue('institution_id', institution?.id?.toString())
  }, [enrolledCourses?.id, institution?.id])

  return (
    <form className={styles.container} onSubmit={handleSubmit(onSubmitForm)}>
      {mutation.isPending && <Loader />}
      <h1>Curso e Instituição</h1>
      <div className={styles.selects}>
        <CustomerSelect
          title="Curso"
          options={courseOptions}
          name="course_id"
          register={{ ...register('course_id') }}
        />
        <CustomerSelect
          title="Instituição"
          options={institutionOptions || []}
          name="institution_id"
          register={{ ...register('institution_id') }}
          onChange={(event) => filterCoursesByInstitution(+event.target.value)}
        />
      </div>
      <FooterButtons
        containerStyles="flex_end"
        right_label="Salvar"
        redirectLink={`/aluno`}
        type="submit"
      />
    </form>
  )
}
